// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        suggestionMobileStyle: 'style1'
    }
};

// Override Settings
(function () {  // Add this
  BoostPFS.inject(this);  // Add this

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {  
  };

  InstantSearch.prototype.afterRender = function (id) {
    function updateSearchPlaceholder() {
      var searchInputs = document.querySelectorAll('.search-bar__input'); // Change this selector to match your search bar input
      var mobileSearchBox = document.querySelector('#boost-pfs-search-box-mobile');
      if (window.innerWidth <= 640) {
        mobileSearchBox.setAttribute('placeholder', 'What are you looking for?');
        searchInputs.forEach(input => {
          input.placeholder = "What are you looking for?";
        });
      }
    }




    // Initial call to set the placeholder on page load
    updateSearchPlaceholder();

    // Add event listener to window resize to update the placeholder dynamically
    window.addEventListener('resize', updateSearchPlaceholder);
  };

  // BoostPFS.prototype.buildSearchResultHeader = function(data){
  // 	jQ('.boost-pfs-filter-breadcrumb').each(function(index, breadcrumb) {
  // 		var html = jQ(breadcrumb).html();
  // 		html = html.replace(/{{terms}}/, Globals.queryParams.q)
  // 		jQ(breadcrumb).html(html);
  // 		jQ(breadcrumb).removeClass('hidden');
  // 	})	
  // };

  // InstantSearch.prototype.beforeInit = function (id) {
  // 	if (Settings.getSettingValue('search.enableSuggestion')) {

  // 		//Remove theme's instant search
  // 		removeThemeSearchEvent();

  // 		var self = this;
  // 		if (typeof id === 'undefined') {
  // 			jQ('input[name="' + this.searchTermKey + '"]').each(function (i) {
  // 				if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
  // 					var id = 'boost-pfs-search-box-' + i;
  // 					jQ(this).attr('id', id);
  // 					self.buildSearchBox('#' + id)
  // 				}
  // 			});
  // 		} else {
  // 			this.buildSearchBox(id);
  // 		}
  // 		if (this.isMobile()) {
  // 			// Clear cache when going back from another page
  // 			window.onpageshow = function (event) {
  // 				if (event.persisted) {
  // 					window.location.reload();
  // 				}
  // 			};
  // 			// Build Suggestion mobile on top
  // 			if (Settings.getSettingValue('search.suggestionMobileStyle') == 'style1') {
  // 				this.buildSuggestionMobile();
  // 			}
  // 		}
  // 	}
  // };

  // function removeThemeSearchEvent() {
  // 	// Remove all events
  // 	if (jQ('.header__search-bar-wrapper').length > 0) {
  // 		var cloneSearchBar = jQ('.header__search-bar-wrapper:first').clone();
  // 		jQ('.header__search-bar-wrapper').replaceWith(cloneSearchBar);
  // 		jQ('.search-bar__filter').hide();
  // 	}
  // 	// Rebuild some event
  // 	if (jQ('[data-action="toggle-search"]').length > 0) {
  // 		jQ('[data-action="toggle-search"]').on('click', function () {
  // 			jQ('.header__search-bar-wrapper').toggleClass('is-visible');
  // 		})
  // 	}
  // 	if (jQ('[data-action="clear-input"]').length > 0) {
  // 		jQ('[data-action="clear-input"]').on('click', function () {
  // 			jQ('input[name="' + bcsffilter.searchTermKey + '"]').val('');
  // 		})
  // 	}
  // }
  
 var bindEvents = InstantSearchMobile.prototype.bindEvents;

  InstantSearchMobile.prototype.bindEvents = function() {
      bindEvents.call(this);

      var self = this;

      jQ('.header__action-item-link[data-action="toggle-search"]').off('click').click(function(e) {
        e.preventDefault();
        //e.stopPropagation();
        jQ('.search-bar__input').focus();
        self.openSuggestionMobile();

      });

  }
  
  var originalcloseInstantSearchMobile = InstantSearchMobile.prototype.closeInstantSearchMobile;
    InstantSearchMobile.prototype.closeInstantSearchMobile = function(isClose) {
          // Call the original function in our app lib.
          // We don't have to copy a very big function out here to modify.
          // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
          originalcloseInstantSearchMobile.call(this,isClose);

          // Do your custom code after the original function has run

        jQ('.header__search-bar-wrapper').removeClass('is-visible');


    }
    
    InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
		switch (tempType) {
			case InstantSearchResultItemProduct.tempType.IMAGE:
				return `
					<div class="{{class.searchSuggestion}}-left">
						<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
					</div>
				`.trim();
			case InstantSearchResultItemProduct.tempType.SKU:
				return `
					<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.VENDOR:
				return `
					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
					</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE_SALE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						<s>{{compareAtPrice}}</s>&nbsp;
						<span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>
					</p>
				`.trim();
			default:
				return `
					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
							{{itemProductImage}}
							<div class="{{class.searchSuggestion}}-right">
								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
								{{itemProductSku}}
								{{itemProductVendor}}
								{{itemProductPrice}}
								{{itemProductReviews}}
							</div>
						</a>
					</li>
				`.trim();
		}
	}
  

    InstantSearchResultItemProduct.prototype.compileTemplate = function() {
      if (this.isShow) {
        var searchTerm = Utils.stripHtml(Globals.currentTerm);
        // Product image
        var imageHTML = '';
        if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
          imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
          imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
        }
        // Product title
        var productTitle = this.customizeProductTitle();
        productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
        // SKU
        var skuHTML = '';
        if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
          skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
          skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
        }
        // Vendor
        var vendorHTML = '';
        if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
          vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
          vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
        }
        // Price
        var priceHTML = this.compileSuggestionProductPrice();
        // Open the result item in new tab when selected
        var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

        var data = this.data;
        var itemReviewHtml = '<div class="grid-view-item__reviews"><div class="yotpo bottomLine" data-appkey="......." data-domain="' + Utils.escape(boostPFSConfig.shop.domain) + '" data-product-id="' + data.id + '" data-product-models="' + data.id + '" data-name="' + data.title + '" data-url="{{itemUrl}}" data-description="{{itemDescription}}" data-bread-crumbs="{{itemTags}}"></div></div>'; 
        itemReviewHtml = itemReviewHtml.replace(/{{itemReviews}}/g, itemReviewHtml); 
        var itemDescription = data.description ? data.description : ''; 
        itemDescription = itemDescription.substr(0, itemDescription.indexOf('##highlights##')); 
        itemReviewHtml = itemReviewHtml.replace(/{{itemDescription}}/g, itemDescription); 
        itemReviewHtml = itemReviewHtml.replace(/{{itemTags}}/g, Utils.escape(data.tags.join(';')));
        itemReviewHtml = itemReviewHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        
        return this.getTemplate()
        .replace(/{{id}}/g, this.id)
        .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
        .replace(/{{url}}/g, this.url)
        .replace(/{{newTabAttribute}}/g, newTabAttr)
        .replace(/{{itemProductImage}}/g, imageHTML)
        .replace(/{{title}}/g, productTitle)
        .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
        .replace(/{{itemProductSku}}/g, skuHTML)
        .replace(/{{itemProductVendor}}/g, vendorHTML)
        .replace(/{{itemProductPrice}}/, priceHTML)
        .replace(/{{itemProductReviews}}/g, itemReviewHtml)
        .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
        .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
        .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
      } else {
        return '';
      }
    }
    
    InstantSearchResult.prototype.afterRender = function(){
      setTimeout(function() {
      	if (typeof Yotpo !== 'undefined') {  var api = new Yotpo.API(yotpo);  api.refreshWidgets();
                  yotpo.onAllWidgetsReady(function(){             
                        setTimeout(function(){
                           document.querySelectorAll(".grid-view-item__reviews .star-clickable a").forEach(function(item){  
                              var plink = item.closest("div[data-url]").attributes["data-url"].value;
                              item.attributes.href.value = plink + "?reviews=y";
                          });                          
                        }, 1200);
                    });                            
              }
      }, 500)
    }
    
})();  // Add this at the end